

export default d => d;